

export default d => d;